import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { ContentPreview } from '../../../../../ContentPreview'
import { GetContentByIDV2Return } from '../../../../helpers/types'
import { validations } from '../../../../helpers/validations'
import { TwitterSingleFooter } from '../../../sharedDisplays/footers/TwitterSingleFooter'
import { TwitterSingleHeader } from '../../../sharedDisplays/headers/TwitterSingleHeader'
import { sharedStyles } from '../shared/styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  display: string
  getContentByIdV2?: (id: number) => Promise<GetContentByIDV2Return>
  isAccountPremium?: boolean
  isPresenting: boolean
  onContentChange: (val: string) => void
  onRefreshChange: (val: string, dest: string) => void
  onRetweetUrlChange: (val: string, dest: string) => void
  onSnapshotUrlChange: (val: string, dest: string) => void
  readOnly: boolean
  refreshedAt: string
  retweetUrl: string
  scheduledAt: string
  snapshotUrl: string
  timezone: string
}

export const Single: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  display = 'desktopSingle',
  getContentByIdV2,
  isAccountPremium,
  isPresenting,
  onContentChange,
  onRefreshChange,
  onRetweetUrlChange,
  onSnapshotUrlChange,
  readOnly,
  refreshedAt,
  retweetUrl,
  scheduledAt,
  snapshotUrl,
  timezone,
}) => (
  <Fragment>
    <TwitterSingleHeader
      accountImage={accountImage}
      accountName={accountName}
      accountUsername={accountUsername}
      content={content}
      isAccountPremium={isAccountPremium}
      isMobile={display.includes('mobile')}
      onContentChange={onContentChange}
      readOnly={readOnly}
    />
    <div css={sharedStyles.getRetweetWrapper(false)}>
      <ContentPreview
        embeddedUrl={retweetUrl}
        snapshotUrl={snapshotUrl}
        embeddedUrlRegex={validations.twitterUrlValidation}
        refreshedAt={refreshedAt}
        isPresenting={isPresenting}
        readOnly={readOnly}
        getContentByIdV2={getContentByIdV2}
        onRefreshChange={(val: string) => onRefreshChange(val, 'refreshed_at')}
        onEmbeddedUrlChange={(val: string) =>
          onRetweetUrlChange(val, 'retweet_url')
        }
        onSnapshotUrlChange={(val: string) =>
          onSnapshotUrlChange(val, 'snapshot_url')
        }
        display={display}
      />
    </div>
    <TwitterSingleFooter
      isMobile={display.includes('mobile')}
      scheduledAt={scheduledAt}
      timezone={timezone}
    />
  </Fragment>
)
